// https://vuex.vuejs.org/en/actions.html

import RestHelper from './../plugins/rest_helpers.js'
import Amplify from 'aws-amplify'

export default {

  loadCurrentUserLicenseData(context) {
    RestHelper.getUserInfo(context.getters.currentUserSub)
    .then(
      user_info => {
        const licenseData = new Map(JSON.parse(user_info.data.licenses));
        context.commit("setCurrentUserLicenseData", licenseData);
        context.commit("setCurrentUserPowerMode", user_info.data.isPowerUser);

        if(user_info.data.isPowerUser) {
          context.dispatch("loadAdminUserData");
        }
      }
    );
  },

  loadAdminUserData(context) { 
    context.dispatch("loadAvailableLidarsData");
    context.dispatch("loadAllowFeatures");
    return RestHelper.getAllUsersInfo()
    .then(
      response => {
        context.commit("setAdminUsersData", response.data);
      }
    );
  },

  updateAdminUserData(context, user_id) {
    RestHelper.getUserInfo(user_id)
    .then( 
      user_info => {
        context.commit("setAdminUserData", { id: user_id, data: user_info.data } );
      });
  },

  loadAvailableLidarsData(context) { 
    return RestHelper.getAvailableLidars()
    .then(
      response => {
        context.commit("setAvailableLidars", JSON.parse(response.data));
      }
    );
  },
  loadAllowFeatures(context) { 
    return RestHelper.getAllAllowFeatures()
    .then(
      response => {
        context.commit("setAllowFeatures", JSON.parse(response.data));
      }
    );
  },

  showSuccessSnack(context, message) {
    context.commit("setSnackInfo", { color: "info", message : message });
  },

  showFailureSnack(context, message) {
    context.commit("setSnackInfo", { color: "error", message : message });
  },

  tryAuthenticateUser(context) {
    Amplify.Auth.currentAuthenticatedUser()
    .then( 
      user => {
        context.commit("setCurrentUser", user);
        context.dispatch("loadCurrentUserLicenseData");
       } )
    .catch(e => window.console.log(e));
  },

  signOut(context) {
    context.commit("setCurrentUserPowerMode", false)
    Amplify.Auth.signOut()
  }
}
